import { Routes, Route } from "react-router-dom";

import styles from "../common/Page.module.css";
import Content from "./Content";

export default function AboutPage() {
  return (
    <div className={styles.Page}>
      <div className={styles.ContentContainer}>
        <Routes>
          <Route path="message" element={<Content id="0" />} />
          <Route path="organization" element={<Content id="1" />} />
          <Route path="history" element={<Content id="2" />} />
        </Routes>
      </div>
    </div>
  );
}
